/**
 * Register bootstrap component js for things
 * like tooltips
 * Bootstrap Templates
 */
const mrcBootstrapJS = (function (window, jQuery) { // eslint-disable-line no-unused-vars
	'use strict';

	function setBootstrapJs () {
		jQuery('[data-toggle="tooltip"], .mrc-tooltip').tooltip();

          jQuery('body').on('click','label',function(e){
               if(jQuery(this).find(':input[disabled]').length > 0){
                    e.stopImmediatePropagation();
                    e.preventDefault();
               }
          })
	}

	return {
		setBootstrapJs: setBootstrapJs
	};
}(window, jQuery));
